// Fall Letter
const fallLetter = {
  id: 3,
  dateArchived: '2026-09-03',
  title: 'Fall Letter',
  isNew: false,
  letterContent: {
    text: `i think i finally know why i miss you the most when fall comes around. the way the air gets crispier with a hint of wood smoke, the way leaves slowly turn gold then brown then fall down. fall is change, and somehow that became our season too.

fall is the season i shakily asked you to marry me, and you said yes without hesitation. fall is the season we first started dating, two dumb college kids who didn't know yet how lucky they'd gotten. fall is blankets and horror movies and my arm around you while hocus pocus plays for the tenth time and neither of us are actually surprised, just warm. fall is the pumpkin patch, both of us squinting into the sun for a good picture, you always laughing right as i take it.

i keep thinking about how the happiest memories of my life all seem to live in this one season, like autumn kept a little museum of us. and if i'm honest, my happiest memories from my whole life, not just the fall ones, all have you standing somewhere in them. you're in the background of every good day i can remember and the center of most of them.

i've been doing a lot of reflecting lately, more than i meant to, the kind that sneaks up on you at random moments at night. and every time it lands in the same place. i am so lucky. lucky that my best friend is also the person i get to marry. lucky that you're my loudest cheerleader even from far away. lucky that whenever the ground feels unsteady, you're the one i lean on, even through a screen, even across all this distance.

i miss you most in the fall because fall is when i can feel most clearly how much you've shaped my life. but i love you every season, in every version of us, and i can't wait for the fall when the distance is finally over and i get to have all of this, all of you, up close again.`,
    image: '',
    greeting: 'my dear reegs,',
    closing: 'yours always',
    signature: 'Alex'
  }
};

export default fallLetter;
